import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Col, Tag, Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handlePainTypeChange } from "../../redux-toolkit/slices/painEntryFormSlice";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";

const painTypes: string[] = painEntryFormConstants.painTypes;

const TePainType = () => {
  const checkedPainTypes = useSelector(
    (state: RootState) => state.painEntryForm.painTypes
  );
  const dispatch = useDispatch();
  // const [checkedPainTypes, setCheckedPainTypes] = useState<string[]>([]);

  // const handlePainTypeChange = (painType: string) => {
  //   const currentIndex = checkedPainTypes.indexOf(painType);
  //   const newCheckedPainTypes = [...checkedPainTypes];

  //   if (currentIndex === -1) {
  //     newCheckedPainTypes.push(painType);
  //   } else {
  //     newCheckedPainTypes.splice(currentIndex, 1);
  //   }

  //   setCheckedPainTypes(newCheckedPainTypes);
  // };

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Pain type *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Which of these words best describe your pain? Understanding your pain can help you find the best way to manage it.
      </p>
      <Row gutter={[16, 20]}>
        {painTypes.map((painType) => (
          <Col
            key={painType}
            xl={6}
            xxl={6}
            lg={6}
            md={8}
            sm={8}
            xs={8}
            style={{ display: "flex" }}
          >
            <Tag.CheckableTag
              checked={checkedPainTypes.includes(painType)}
              onChange={() => dispatch(handlePainTypeChange(painType))}
              className="checkable-tag-pain-entry"
            >
              {painType}
            </Tag.CheckableTag>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TePainType;
